module.exports = __webpack_public_path__ + "img/calendar-arrow-down.e9c8eb01.svg";